module.exports = __webpack_public_path__ + "img/sunbed.459a52f5.svg";